const cloneObject = (o: any) => !!o ? JSON.parse(JSON.stringify(o)) : undefined;

export default cloneObject;